import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";

// Config from Firebase Console
const firebaseConfig = {
    apiKey: "AIzaSyBS1w1msotKtOPSzNYtOieBhnF3ATsVxwY",
    authDomain: "entourage-ai.firebaseapp.com",
    projectId: "entourage-ai",
    storageBucket: "entourage-ai.firebasestorage.app",
    messagingSenderId: "143841299244",
    appId: "1:143841299244:web:3554ae399504e085b23a89",
    measurementId: "G-V823BG74VW"
};

// Check if we are running inside the Tauri desktop app
// Check if we are running in development mode
const isDev = process.env.NODE_ENV === 'development';

if (isDev) {
    firebaseConfig.projectId = "entourage-ai";
    firebaseConfig.storageBucket = "entourage-ai.appspot.com";
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, 'australia-southeast1');
const storage = getStorage(app);

// Connect to Emulators if on localhost
if (isDev) {
    try {
        connectAuthEmulator(auth, "http://localhost:9099");
        connectFirestoreEmulator(db, 'localhost', 8080);
        connectFunctionsEmulator(functions, 'localhost', 5001);
        connectStorageEmulator(storage, 'localhost', 9199);
        console.log("🔥 Connected to Firebase Emulators");
    } catch (error) {
        console.error("Error connecting to emulators:", error);
    }
}

export { auth, db, functions, storage };

export default app;
